import React from 'react';
import { SearchBox } from 'components/categoryHelpers/searchBox/SearchBox';
import { TableInfo } from 'api';
import Button from 'components/button/Button';

export type PageHeaderProps = {
    pageTitle: string;
    table: TableInfo;
    changeSearch?(searchString: string): void;
    initialSearchString: string;
    addButtonText: string;
    onAddButtonClick?(): void;
    onOpenFilters?: any;
    noAddBtn: boolean;
    customAddButtons?: React.ReactNode | React.ReactNode[];
};

const PageHeader: React.FC<PageHeaderProps> = ({
    pageTitle,
    table,
    changeSearch,
    initialSearchString,
    addButtonText,
    onAddButtonClick,
    noAddBtn,
    customAddButtons,
}) => {
    return (
        <div className="PageHeader">
            <h1 style={{ marginBottom: '0' }} className="notranslate" translate="no">{pageTitle}</h1>
            <div className="HeaderActionsContainer">
                {(table?.data?.details as any).bHasSearchField && (
                    <SearchBox
                        key={initialSearchString}
                        changeSearch={changeSearch}
                        initialSearchString={initialSearchString}
                        goToPage={table.data?.actions.goToPage}
                    />
                )}
                {noAddBtn && noAddBtn === true ? null : customAddButtons ? (
                    customAddButtons
                ) : (
                    <div className="Buttons">
                        {onAddButtonClick && (
                            <Button onClick={onAddButtonClick}><span className="notranslate" translate="no">{addButtonText}</span></Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export { PageHeader };
